// Lib
import { createAction } from '@reduxjs/toolkit';

export const SetPrevPath = createAction('SET_PREV_PATH');
export const ClearPrevPath = createAction('CLEAR_PREV_PATH');
